<template>
  <div class="edit-seat-modal-component">
    <v-text-field :disabled="true" variant="outlined" :label="$t('seatEditor.editSeatModal.content.seatNumber')" v-model="seatAttrs.number"></v-text-field>
    <v-text-field :disabled="true" variant="outlined" :label="$t('seatEditor.editSeatModal.content.rowNumber')" v-model="seatAttrs.row"></v-text-field>
    <v-text-field :disabled="true" variant="outlined" :label="$t('seatEditor.editSeatModal.content.colNumber')" v-model="seatAttrs.col"></v-text-field>
    <div class="flex-content">
      <v-text-field :disabled="isMultiple" class="first" variant="outlined" :label="$t('seatEditor.editSeatModal.content.xCord')" v-model="seatAttrs.xCord"></v-text-field>
      <v-text-field :disabled="isMultiple" class="second" variant="outlined" :label="$t('seatEditor.editSeatModal.content.yCord')" v-model="seatAttrs.yCord"></v-text-field>
    </div>
    <div class="flex-content">
      <v-text-field :disabled="isMultiple" class="first" variant="outlined" :label="$t('seatEditor.editSeatModal.content.height')" v-model="seatAttrs.height"></v-text-field>
      <v-text-field :disabled="isMultiple" class="second" variant="outlined" :label="$t('seatEditor.editSeatModal.content.width')" v-model="seatAttrs.width"></v-text-field>
    </div>
    <v-text-field :disabled="isMultiple" variant="outlined" :label="$t('seatEditor.editSeatModal.content.rotation')" v-model="seatAttrs.rotation"></v-text-field>
    <v-btn class="save-btn" color="primary" @click="handleSave"> {{ $t('seatEditor.editSeatModal.buttons.save') }} </v-btn>
    <v-btn class="delete-btn" variant="text" color="red" @click="handleRemove"> {{ $t('seatEditor.editSeatModal.buttons.delete') }} </v-btn>
  </div>
</template>

<script>
export default {
  name: "EditSeatModalComponent",
  props: {
    item: {
      type: Object,
      required: true,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    needRefresh: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      seatAttrs: {
        number: undefined,
        row: undefined,
        col: undefined,
        xCord: undefined,
        yCord: undefined,
        height: undefined,
        width: undefined,
        rotation: undefined,
      },
      canRefreshData: true,
    }
  },
  mounted() {
    if (!this.isMultiple) {
      this.getSeatAttrs();
    }
  },
  methods: {
    getSeatAttrs() {
      this.seatAttrs.number = this.item.attrs.number;
      this.seatAttrs.row = this.item.attrs.rowIndex;
      this.seatAttrs.col = this.item.attrs.colIndex;
      this.seatAttrs.xCord = this.item.getAbsolutePosition().x.toFixed(0);
      this.seatAttrs.yCord = this.item.getAbsolutePosition().y.toFixed(0);
      const calculatedHeight = this.item.attrs.scaleY ? this.item.attrs.height * this.item.attrs.scaleY : this.item.attrs.height;
      this.seatAttrs.height = Number(calculatedHeight).toFixed(0);
      const calculatedWidth = this.item.attrs.scaleX ? this.item.attrs.width * this.item.attrs.scaleX : this.item.attrs.width;
      this.seatAttrs.width = Number(calculatedWidth).toFixed(0);
      const calculatedRotation = this.item.attrs.rotation ? Number(this.item.attrs.rotation).toFixed(0) : 0;
      this.seatAttrs.rotation = calculatedRotation;
    },
    closeModal() {
      this.$emit('closeModal');
    },
    handleRemove() {
      this.$emit('removeSeat');
    },
    handleSave() {
      this.$emit('saveSeat', this.seatAttrs);
    },
  },
  watch: {
    // item: {
    //   handler() {
    //     if(document.activeElement.tagName == 'BODY' && !this.isMultiple /* && this.canRefreshData */) {
    //       // setTimeout(() => {
    //         this.getSeatAttrs();
    //       // }, 3000);
    //       // this.canRefreshData = false;
    //       // setTimeout(() => {
    //       //   this.canRefreshData = true;
    //       // }, 1100);
    //     }
    //   },
    //   deep: true,
    // },
    needRefresh(newValue) {
      if (newValue == true && !this.isMultiple) {
        this.getSeatAttrs();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-seat-modal-component {
  padding: 0 4px;
  .flex-content {
    display: flex;
    .first {
      margin-right: 4px;
    }
    .second {
      margin-left: 4px;
    }
  }
  .save-btn {
    width: 100%;
    margin-bottom: 8px;
  }
  .delete-btn {
    width: 100%;
  }
}
</style>